import React from "react";
import { CheckCircle2, Users } from "lucide-react";
import { Badge } from "../../ui/badge";
import { MultiApprovalWorkflow } from "./Api/multiapprovalapi";

interface MultiApprovalListSummaryProps {
  workflow: MultiApprovalWorkflow;
}

export default function MultiApprovalListSummary({ workflow }: MultiApprovalListSummaryProps) {
  const approvals = workflow.groupedApprovals.flatMap((group) =>
    group.approvals.map((approval) => ({
      ...approval,
      groupName: group.groupName,
    })),
  );

  return (
    <div className="p-3 rounded-lg border border-indigo-200 dark:border-indigo-800 bg-indigo-50/60 dark:bg-indigo-950/20">
      <div className="flex items-center gap-2 mb-2">
        <Users className="w-3.5 h-3.5 text-indigo-600 dark:text-indigo-400" />
        <Badge
          variant="outline"
          className="text-indigo-700 border-indigo-300 bg-indigo-50 dark:bg-indigo-950/30 dark:text-indigo-300 dark:border-indigo-700"
        >
          Multi-Approval
        </Badge>
      </div>

      {approvals.length > 0 ? (
        <ul className="space-y-1">
          {approvals.map((approval) => (
            <li
              key={`${approval.groupUuid}-${approval.approverEmail}-${approval.approvedAt}`}
              className="flex items-center gap-1.5 text-xs text-indigo-800 dark:text-indigo-200"
            >
              <CheckCircle2 className="w-3 h-3 shrink-0 text-green-600 dark:text-green-400" />
              <span>
                {approval.approverDisplayName || approval.approverEmail}
                <span className="text-indigo-500 dark:text-indigo-400"> · {approval.groupName}</span>
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-xs text-indigo-600 dark:text-indigo-400">Awaiting approvals</p>
      )}
    </div>
  );
}
